import ChangeRequest from '../../base/notifications/ChangeRequest';

const changeRequest: ChangeRequest = {
  created: {
    title: '{airdomeName}',
    message: 'Request by {author} to change {type} was created.'
  },
  finished: {
    title: '{airdomeName}',
    message: 'Request by {author} to change {type} completed.'
  },
  failed: {
    title: '{airdomeName}',
    message: 'Request by {author} to change {type} failed.'
  }
};

export default changeRequest;
